module.exports = __webpack_public_path__ + "static/media/usa-today.6b835a87.jpg";